import { render } from "./PageLoader.vue?vue&type=template&id=4c1f764e&scoped=true&ts=true"
import script from "./PageLoader.vue?vue&type=script&lang=ts"
export * from "./PageLoader.vue?vue&type=script&lang=ts"

import "./PageLoader.vue?vue&type=style&index=0&id=4c1f764e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1f764e"]])

export default __exports__